var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"title":_vm.prefix}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'หน้าแรก',
          icon: 'fas fa-tachometer-alt',
          path: '/dashboard',
        }}}),(_vm.hasPermission('manage.members'))?_c('sidebar-item',{attrs:{"link":{
          name: 'รายการสมาชิก',
          icon: 'fas fa-users',
          path: '/dashboard/members',
        }}}):_vm._e(),(_vm.hasPermission('manage.fixTx'))?_c('sidebar-item',{attrs:{"link":{
          name: 'แก้ไขรายการ',
          icon: 'fas fa-edit',
          path: '/dashboard/fix-tx',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'รายการฝาก / ถอน',
          icon: 'fas fa-university',
        }}},[(_vm.hasPermission('manage.deposit'))?_c('sidebar-item',{attrs:{"link":{
            name: 'รายการฝาก',
            path: '/dashboard/deposit',
          }}}):_vm._e(),(_vm.hasPermission('manage.withdraw'))?_c('sidebar-item',{attrs:{"link":{
            name: 'รายการถอน',
            path: '/dashboard/withdraw',
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: 'รายการเงินเข้า',
            path: '/dashboard/bank-transactions',
          }}})],1),(
          _vm.hasPermission('manage.bonus') ||
          _vm.hasPermission('manage.wheel') ||
          _vm.hasPermission('manage.redeem')
        )?_c('sidebar-item',{attrs:{"link":{ name: 'โปรโมชั่น', icon: 'fas fa-gift' }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'โบนัสทั่วไป',
            path: '/dashboard/promotion/bonus',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'แจกเครดิต (สมาชิกใหม่)',
            path: '/dashboard/promotion/new-reg-bonus',
          }}}),(_vm.hasFeature('wheel') && _vm.hasPermission('manage.wheel'))?_c('sidebar-item',{attrs:{"link":{
            name: 'กงล้อเสี่ยงโชค',
            path: '/dashboard/wheel',
          }}}):_vm._e(),(_vm.hasFeature('redeem') && _vm.hasPermission('manage.redeem'))?_c('sidebar-item',{attrs:{"link":{
            name: 'โค๊ดโปรโมชั่น',
            path: '/dashboard/promotion/redeem',
          }}}):_vm._e(),(_vm.hasFeature('cashback'))?_c('sidebar-item',{attrs:{"link":{
            name: 'คืนยอดเสีย (Cashback)',
            path: '/dashboard/promotion/cashback',
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: 'แนะนำเพื่อน (Affiliate)',
            path: '/dashboard/promotion/affiliate',
          }}})],1):_vm._e(),(_vm.hasPermission('manage.summary'))?_c('sidebar-item',{attrs:{"link":{ name: 'กราฟ', icon: 'fas fa-chart-pie' }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'รายการฝาก',
            path: '/dashboard/summary/deposit',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'รายการถอน',
            path: '/dashboard/summary/withdraw',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'รายการสมัครสมาชิก',
            path: '/dashboard/summary/register',
          }}})],1):_vm._e(),(_vm.hasPermission('manage.summary'))?_c('sidebar-item',{attrs:{"link":{ name: 'รายงานสรุป', icon: 'fas fa-list' }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'รายงานโบนัส',
            path: '/dashboard/summary/bonus',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'รายงานโค๊ดโปรโมชั่น',
            path: '/dashboard/summary/redeem',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'รายงานกงล้อเสี่ยงโชค',
            path: '/dashboard/summary/wheel',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'รายงานแคชแบ็ก',
            path: '/dashboard/summary/cashback',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'รายงานแนะนำเพื่อน',
            path: '/dashboard/summary/affiliate',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'รายงานฝาก/ถอนรายบุคคล',
            path: '/dashboard/summary/report-by-member',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'สรุปข้อมูล',
            path: '/dashboard/summary',
          }}})],1):_vm._e(),(_vm.hasPermission('manage.bank'))?_c('sidebar-item',{attrs:{"link":{ name: 'ธนาคาร', icon: 'fas fa-university' }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'ตั้งค่าธนาคาร',
            path: '/dashboard/bank',
          }}}),(_vm.hasFeature('scbDeposit') || _vm.hasFeature('scbWithdraw'))?_c('sidebar-item',{attrs:{"link":{
            name: 'SCB API',
            path: '/dashboard/scb',
          }}}):_vm._e()],1):_vm._e(),(_vm.hasPermission('manage.users'))?_c('sidebar-item',{attrs:{"link":{
          name: 'รายการแอดมิน',
          icon: 'fas fa-users',
          path: '/dashboard/users',
        }}}):_vm._e(),(_vm.hasPermission('manage.website'))?_c('sidebar-item',{attrs:{"link":{
          name: 'เว็บไซต์',
          icon: 'fas fa-cogs',
          path: '/dashboard/setting',
        }}}):_vm._e(),(_vm.hasPermission('manage.website'))?_c('sidebar-item',{attrs:{"link":{
          name: 'บันทึกกิจกรรม',
          icon: 'fas fa-terminal',
          path: '/dashboard/log',
        }}}):_vm._e(),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://kb.msn.bet","target":"_blank"}},[_c('i',{staticClass:"fas fa-book"}),_c('span',{staticClass:"nav-link-text"},[_vm._v("คู่มือการใช้งาน")])])])],1)],2),_c('div',{staticClass:"main-content"},[_c('base-nav',{staticClass:"navbar-top border-bottom navbar-expand navbar-dark bg-dark",attrs:{"container-classes":"container-fluid"}},[_c('ul',{staticClass:"navbar-nav align-items-center ml-md-auto"},[_c('li',{staticClass:"nav-item d-xl-none"},[_c('div',{staticClass:"pr-3 sidenav-toggler",on:{"click":_vm.toggleSidebar}},[_c('div',{staticClass:"sidenav-toggler-inner"},[_c('i',{staticClass:"sidenav-toggler-line"}),_c('i',{staticClass:"sidenav-toggler-line"}),_c('i',{staticClass:"sidenav-toggler-line"})])])])]),_c('ul',{staticClass:"navbar-nav align-items-center ml-auto ml-md-0"},[_c('base-dropdown',{staticClass:"nav-item",attrs:{"tag":"li","title-tag":"a","title-classes":"nav-link pr-0","title":_vm.prefix,"menu-on-right":""}},[[_c('button',{staticClass:"dropdown-item",on:{"click":_vm.triggerLogout}},[_c('i',{staticClass:"fas fa-sign-out-alt"}),_c('span',[_vm._v("ออกจากระบบ")])])]],2)],1)]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid mt-4"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }